import React from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';
import './Collection.css';
import TextField from 'material-ui/TextField';

export default class Collection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      modifications: {}
    };
  }


  handleChange = (id, value) => {
    // find the matching product
    var products = this.props.products;
    var matchedProduct = null;
    for (var i=0; i < products.length; i++) {
      if (products[i].id === id) {
        matchedProduct = products[i];
        break;
      }
    }

    // update the modifications
    const modifications = this.state.modifications;
    modifications[id] = value;
    if (matchedProduct.quantity === value){
      delete modifications[id];
    }else{
      modifications[id] = value;
    }
    this.setState({
      modifications: modifications
    });
  };

  render() {
    return (
      <div className="collection">
       <Toolbar>
          <ToolbarGroup firstChild={true}>
            <ToolbarTitle text={this.props.match.params.id}/>
          </ToolbarGroup>
          <ToolbarGroup>
            <RaisedButton label="Save" primary={true} disabled={Object.keys(this.state.modifications).length > 0 ? false: true}/>
          </ToolbarGroup>
        </Toolbar>
        <Table selectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn>Product</TableHeaderColumn>
              <TableHeaderColumn>Quantity</TableHeaderColumn>
              <TableHeaderColumn>Price</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
          {this.props.products.map((product) => (
            <Product 
              handleChange={this.handleChange}
              key={product.id} 
              productid={product.id} 
              name={product.name} 
              quantity={product.quantity} 
              after={this.state.modifications[product.id]}
              price={product.price} />
          ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

Collection.propTypes = {
  products: React.PropTypes.array.isRequired,
  updateInventory: React.PropTypes.func,
}

class Product extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: "",
      value: this.props.quantity
    };
  }

  isInt(value) {
    if (isNaN(value)) {
      return false;
    }
    var x = parseFloat(value);
    return (x | 0) === x;
  }

  handleChange = (e) => {
    // validate the input
    if (this.isInt(e.target.value) && Number(e.target.value) < 1000){
      this.setState({
        error: "",
      });
      this.props.handleChange(e.target.id, Number(e.target.value));
    }
    else{
      this.setState({
        error: "Invalid quantity",
      });
    }
  }

  render() {
    return (
      <TableRow key={this.props.productid} >
        <TableRowColumn>{this.props.name}</TableRowColumn>
        <TableRowColumn>
          <TextField 
            id={this.props.productid}
            defaultValue={this.props.after ? this.props.after: this.props.quantity} 
            errorText={this.state.error}
            onChange={this.handleChange}
            floatingLabelText={this.props.after ? "before: " + this.props.quantity: ""}
          />
        </TableRowColumn>
        <TableRowColumn>{this.props.price}</TableRowColumn>
      </TableRow>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/merchant/Collection.js